export default __webpack_public_path__ + "static/1-354e290dfa37956ce061cb96df365a56.png";